module.exports = __webpack_public_path__ + "img/grey-14days.cde0c936.png";